/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- MONETIZATION - VIDEO AD PAGE : STYLES --------------- ++++++++++ */
export default {
    insticatorSSP: {
    }
};
